import { Captions, CaptionsOff } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { useBreakpoint } from "@core/hooks/useBreakpoint";

const LiveTranscriptionIcon = () => {
  return (
    <div
      aria-hidden="true"
      className="w-2 h-2 bg-brand-600 rounded-full animate-pulse"
    ></div>
  );
};

export type Props = {
  isTranscribing: boolean;
  isLoading: boolean;
  onClick: () => void;
};

export function VideoMeetingControlsTranscription({
  isTranscribing,
  isLoading,
  onClick,
}: Props) {
  const isMdScreen = useBreakpoint("md");

  return (
    <Button
      variant="ghost"
      theme="dark"
      iconComponent={
        isTranscribing
          ? isMdScreen
            ? LiveTranscriptionIcon
            : Captions
          : CaptionsOff
      }
      onClick={onClick}
      isLoading={isLoading}
      destructive={!isTranscribing}
      role="switch"
      aria-checked={isTranscribing}
      aria-label={isTranscribing ? "Hide captions" : "Show captions"}
    >
      {isMdScreen ? "CC" : ""}
    </Button>
  );
}

export default VideoMeetingControlsTranscription;
